import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconName } from 'app/backpack-icons/backpack-icon.component';
import { BackpackIconsModule } from 'app/backpack-icons/backpack-icons.module';
import { BetaPillComponent } from './beta-pill.component';

/**
 * This component is a tab in the sidenav. It primarily serves as a visual building block,
 * and you should rarely need to use this component directly. For common use cases,
 * @see SidenavRouteTabComponent and @see SidenavExpandingTabComponent.
 */
@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [BetaPillComponent, BackpackIconsModule, CommonModule],
	selector: 'sp-sidenav-tab',
	template: `
		<bp-icon size="22" [icon]="icon"></bp-icon>
		<div class="sidenav-tab_label">{{ label }}</div>
		<sp-beta-pill *ngIf="isBeta" class="tw-text-button1"></sp-beta-pill>
		<bp-icon class="sparkles" *ngIf="isSparkly" size="20" icon="sparkles"></bp-icon>
		<bp-icon class="expander" *ngIf="doesExpand" size="16" icon="chevron-expand"></bp-icon>
	`,
	styleUrls: ['./sidenav-tab.component.scss'],
	host: {
		'[class.active]': 'isActive',
		'[class.expanded]': 'isExpanded',
	},
})
export class SidenavTabComponent {
	@Input() icon: IconName = 'admin';
	@Input() label = '';
	@Input() isActive = false;

	// These inputs control the decorators on the tab
	@Input() isSparkly = false;
	@Input() doesExpand = false;
	@Input() isExpanded = false;
	@Input() isBeta = false;
}
